import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { observable, makeObservable } from 'mobx'


@observer
export default class Print extends Component {

    @observable status = 'loading'

    constructor(props){
        super(props)
        makeObservable(this)
    }

    async componentDidMount() {
        const {store} = this.props
        const {survey} = store
        console.log(`surveyAuthLevel = ${store.surveyAuthLevel}`)
        if (survey.metadata.clientId !== 1 && store.surveyAuthLevel[1] < 6) {
            location.href = '/home/e/0106.1'
        } else if (survey.metadata.clientId === 1) {
            try {
                const productInfo = await store.http.get(`/product/${survey.metadata.productInfo.productId}`, store.surveyToken)
                if (productInfo.status !== 5) {
                    location.href = '/home/e/0106.1'
                }
            } catch(e) {
                console.log(e)
                location.href = '/home/e/0106.1'
            }
            
        }
        window.addEventListener("message", function(e){
            const iFrame = document.getElementById("surveyPrint");
            if (iFrame.contentWindow === e.source) {
                iFrame.height = e.data.height + "px";
                iFrame.style.height = e.data.height + "px";
            }
        })

        this.status = 'ready'
    }

    render() {
        const {store} = this.props
        const {survey, tokenData} = store
        return (
            <div>
                { this.status === 'ready' &&
                    <iframe
                        id="surveyPrint"
                        src={`${survey.getPrintLink(store.useLatestUI)}&q=${new Date().getTime()}`}
                        width="100%"
                        height="100%"
                        scrolling="no"
                        frameBorder="0"/>
                }
            </div>
        )
    }
}